/**
 * Typo bold
 */
export var TypographyBold;
(function (TypographyBold) {
    TypographyBold["TEXT_WEIGHT_NORMAL"] = "has-text-weight-normal";
    TypographyBold["TEXT_WEIGHT_MEDIUM"] = "has-text-weight-medium";
    TypographyBold["TEXT_WEIGHT_SEMIBOLD"] = "has-text-weight-semibold";
})(TypographyBold || (TypographyBold = {}));
/**
 * @param typographyBoldType {TypographyBold|string} - Bold type
 * @returns {string} - Bold type
 */
export const getTypographyBoldClassName = (typographyBoldType) => {
    switch (typographyBoldType) {
        case 'TEXT_WEIGHT_NORMAL':
            return 'has-text-weight-normal';
        case 'TEXT_WEIGHT_MEDIUM':
            return 'has-text-weight-medium';
        case 'TEXT_WEIGHT_SEMIBOLD':
            return 'has-text-weight-semibold';
        default:
            return null;
    }
};
/**
 * @param typographyBoldType {TypographyBold|string} - Bold type
 * @param level {}
 * @returns {string} - Bold type
 */
export const getTypographyBoldStyle = (typo, level) => {
    return ((typo && !Array.isArray(typo) && typo === TypographyBold.TEXT_WEIGHT_NORMAL && 'bouygues_read_regular') ||
        (typo && Array.isArray(typo) && typo.includes(TypographyBold.TEXT_WEIGHT_NORMAL) && 'bouygues_read_regular') ||
        (typo && !Array.isArray(typo) && typo === TypographyBold.TEXT_WEIGHT_MEDIUM && 'bouygues_read_medium') ||
        (typo && Array.isArray(typo) && typo.includes(TypographyBold.TEXT_WEIGHT_MEDIUM) && 'bouygues_read_medium') ||
        (typo && !Array.isArray(typo) && typo === TypographyBold.TEXT_WEIGHT_SEMIBOLD && 'bouygues_read_semibold') ||
        (typo && Array.isArray(typo) && typo.includes(TypographyBold.TEXT_WEIGHT_SEMIBOLD) && 'bouygues_read_semibold') ||
        (level && level == 'ONE' && 'bouygues_read_regular') ||
        (level && level == 'TWO' && 'bouygues_read_regular') ||
        (level && level == 'THREE' && 'bouygues_read_regular') ||
        'bouygues_read_regular');
};
//# sourceMappingURL=TypographyBold.js.map